import React from "react";

import PageWrapper from "../../../components/layout/page/PageWrapper";
import PageHeader from "../../../components/layout/page/PageHeader";

import UserSavedPopsView from "../users/saved/views/UserSavedPopsView";

export default function UserSavedPopsPage() {
  return (
    <PageWrapper>
      <PageHeader
        title="Saved Pops"
        description="View and manage your saved Pops."
      />

      <UserSavedPopsView />
    </PageWrapper>
  );
}
